import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { DialogComponent } from '@shared/components/dialog/dialog.component';
import { PATH } from '@constant/path.constant';
import {
  FileData,
  GetDetailResponse,
  GetDetailService,
} from '@shared/service/api/get-detail/get-detail.service';
import { API_PATH } from '@constant/api-path.constant';
import { LoadingComponent } from '@shared/components/loading/loading.component';

@Component({
  selector: 'app-pet-detail',
  standalone: true,
  imports: [CommonModule, LoadingComponent],
  templateUrl: './pet-detail.component.html',
  styleUrl: './pet-detail.component.scss',
})
export class PetDetailComponent {
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private category = '';
  private getdetailService = inject(GetDetailService);
  protected detailData: GetDetailResponse | null = null;
  protected isApiLoading = false;

  constructor() {
    this.isApiLoading = true;
    this.route.paramMap.subscribe((res: ParamMap) => {
      const id = res.get('id') || '';
      this.category = res.get('category') || '';
      this.getdetailService
        .getDetailApi(API_PATH.getDetail, { catid: id })
        .subscribe((data) => {
          this.detailData = data;
          this.isApiLoading = false;
        });
    });
  }
  clickImage(data: FileData) {
    this.dialog.open(DialogComponent, {
      data: {
        path: data.path,
      },
    });
  }
  goBack() {
    this.router.navigate([PATH.petList(this.category)]);
  }
}
